/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tenant-gateway-transaction.reducer';

export const TenantGatewayTransactionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tenantGatewayTransactionEntity = useAppSelector(state => state.tenantGatewayTransaction.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tenantGatewayTransactionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.detail.title">TenantGatewayTransaction</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.id">Id</Translate>
            </span>
          </dt>
          <dd>{tenantGatewayTransactionEntity.id}</dd>
          <dt>
            <span id="success">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.success">Success</Translate>
            </span>
            <UncontrolledTooltip target="success">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.success" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.success ? 'true' : 'false'}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.code">Code</Translate>
            </span>
            <UncontrolledTooltip target="code">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.code" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.code}</dd>
          <dt>
            <span id="message">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.message">Message</Translate>
            </span>
            <UncontrolledTooltip target="message">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.message" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.message}</dd>
          <dt>
            <span id="transactionId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.transactionId">Transaction Id</Translate>
            </span>
            <UncontrolledTooltip target="transactionId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.transactionId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.transactionId}</dd>
          <dt>
            <span id="transactionType">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.transactionType">Transaction Type</Translate>
            </span>
            <UncontrolledTooltip target="transactionType">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.transactionType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.transactionType}</dd>
          <dt>
            <span id="merchantId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.merchantId">Merchant Id</Translate>
            </span>
            <UncontrolledTooltip target="merchantId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.merchantId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.merchantId}</dd>
          <dt>
            <span id="providerReferenceId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.providerReferenceId">Provider Reference Id</Translate>
            </span>
            <UncontrolledTooltip target="providerReferenceId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.providerReferenceId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.providerReferenceId}</dd>
          <dt>
            <span id="amount">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.amount">Amount</Translate>
            </span>
            <UncontrolledTooltip target="amount">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.amount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.amount}</dd>
          <dt>
            <span id="payResponseCode">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.payResponseCode">Pay Response Code</Translate>
            </span>
            <UncontrolledTooltip target="payResponseCode">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.payResponseCode" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.payResponseCode}</dd>
          <dt>
            <span id="trdPtyUtr">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.trdPtyUtr">Trd Pty Utr</Translate>
            </span>
            <UncontrolledTooltip target="trdPtyUtr">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.trdPtyUtr" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.trdPtyUtr}</dd>
          <dt>
            <span id="qrCodeId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.qrCodeId">Qr Code Id</Translate>
            </span>
            <UncontrolledTooltip target="qrCodeId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.qrCodeId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.qrCodeId}</dd>
          <dt>
            <span id="storeId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.storeId">Store Id</Translate>
            </span>
            <UncontrolledTooltip target="storeId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.storeId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.storeId}</dd>
          <dt>
            <span id="terminalId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.terminalId">Terminal Id</Translate>
            </span>
            <UncontrolledTooltip target="terminalId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.terminalId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.terminalId}</dd>
          <dt>
            <span id="userId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.userId">User Id</Translate>
            </span>
            <UncontrolledTooltip target="userId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.userId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.userId}</dd>
          <dt>
            <span id="gatewayResponse">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.gatewayResponse">Gateway Response</Translate>
            </span>
            <UncontrolledTooltip target="gatewayResponse">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.gatewayResponse" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.gatewayResponse}</dd>
          <dt>
            <span id="tenantId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.tenantId">Tenant Id</Translate>
            </span>
            <UncontrolledTooltip target="tenantId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.tenantId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.tenantId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.draft">Draft</Translate>
            </span>
            <UncontrolledTooltip target="draft">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.draft" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{tenantGatewayTransactionEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.timestampEntry}</dd>
          <dt>
            <span id="bankId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.bankId">Bank Id</Translate>
            </span>
            <UncontrolledTooltip target="bankId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.bankId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.bankId}</dd>
          <dt>
            <span id="bankTransactionId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.bankTransactionId">Bank Transaction Id</Translate>
            </span>
            <UncontrolledTooltip target="bankTransactionId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.bankTransactionId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.bankTransactionId}</dd>
          <dt>
            <span id="pgTransactionId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.pgTransactionId">Pg Transaction Id</Translate>
            </span>
            <UncontrolledTooltip target="pgTransactionId">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.pgTransactionId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.pgTransactionId}</dd>
          <dt>
            <span id="pgInstrumentType">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.pgInstrumentType">Pg Instrument Type</Translate>
            </span>
            <UncontrolledTooltip target="pgInstrumentType">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.pgInstrumentType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantGatewayTransactionEntity.pgInstrumentType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.gateway">Gateway</Translate>
          </dt>
          <dd>{tenantGatewayTransactionEntity.gateway ? tenantGatewayTransactionEntity.gateway.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.paymentMode">Payment Mode</Translate>
          </dt>
          <dd>{tenantGatewayTransactionEntity.paymentMode ? tenantGatewayTransactionEntity.paymentMode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.paymentState">Payment State</Translate>
          </dt>
          <dd>{tenantGatewayTransactionEntity.paymentState ? tenantGatewayTransactionEntity.paymentState.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tenant-gateway-transaction" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tenant-gateway-transaction/${tenantGatewayTransactionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TenantGatewayTransactionDetail;
